/**
 * Created by pzf on 2018/12/26
 *
 */
import * as React from 'react';

export default function generator(props) {
  return (BasicComponent) => {
    return class Adapter extends React.PureComponent {
      render() {
        const { prefixCls } = props;
        return <BasicComponent prefixCls={prefixCls} {...this.props} />;
      }
    };
  };
}